import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../cra/src/styling/breakpointsMinWidth';

const Wrapper = styled.section`
  background-color: #efecff;
  padding: 20px 0;
  min-height: 277px;

  @media ${breakpointsMinWidth.tabletSm} {
    padding: 24px 0;
    min-height: 206px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 30px 0;
    min-height: 200px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 30px 0;
    min-height: 184px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding: 32px 0;
    min-height: 240px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 60px 0;
    min-height: 320px;
  }
`;
const Contents = styled.section`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 0 20px;

  @media ${breakpointsMinWidth.tabletMd} {
    width: 95%;
    gap: 20px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    width: 83%;
    gap: 24px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    gap: 40px;
  }
`;
const Image = styled.img`
  width: 120px;
  height: 120px;

  @media ${breakpointsMinWidth.desktopSm} {
    width: 160px;
    height: 160px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 200px;
    height: 200px;
  }
`;

const testimonials = [
  {
    image: 'https://gatsby.wisedoc.net/homepage/Sohan_Sethi.png',
    name: 'Sohan Sethi',
    title: 'LinkedIn Influencer',
    text1: `With the help of Wisedoc’s smart AI suggestions and powerful job search tools, I tailored
      my resume for each role and started getting callbacks from top companies within `,
    highlight: 'two weeks.',
    text2: ` I highly recommend Wisedoc to anyone serious about landing better opportunities and acing your job search!`,
  },
  {
    image: 'https://gatsby.wisedoc.net/homepage/Tony_Munoz.jpg',
    name: 'Tony Munoz',
    title: 'Veteran, US Army',
    text1: `Wisedoc successfully customized its software to meet the unique needs of the Military-Affiliated Program. It now serves both veteran and non-veteran students at the university seamlessly. `,
  },
  {
    image: 'https://gatsby.wisedoc.net/homepage/Jonathan_Stoll.jpg',
    name: 'Jonathan Stoll',
    title: 'Career Advisor',
    text1: `I had a student upload their resume into Wisedoc, and just like that, it was improved — going from really bad to pretty good in no time. Wisedoc made my advising session with the student much more effective. `,
  },
];

const Testimonial = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const testimonial = testimonials[index];

  return (
    <Wrapper className="w-full flex justify-center items-center">
      <Contents>
        <Image
          src={testimonial.image}
          alt={testimonial.name}
          className="rounded-full object-cover"
        />
        <div className="flex-1 text-left">
          <p className="text-[16px] text-[#222] tabletSm:text-[18px] tabletMd:-[20px] leading-[1.25] desktopSm:text-[24px] desktopLg:text-[28px]">
            {testimonial.text1}
            <span className="text-[#2364eb]">{testimonial.highlight}</span>
            {testimonial.text2}
          </p>
          <div className="flex gap-[4px]">
            <div className="text-[16px] text-[#2364eb]  leading-[1.25] tabletSm:text-[18px] tabletMd:-[20px] font-medium desktopSm:text-[24px] desktopLg:text-[28px]">
              {testimonial.name}
            </div>
            <div className="text-[16px] leading-[1.25] tabletSm:text-[18px] tabletMd:-[20px] font-light text-[#222] desktopSm:text-[24px] desktopLg:text-[28px]">
              | {testimonial.title}
            </div>
          </div>
        </div>
      </Contents>
    </Wrapper>
  );
};

export default Testimonial;
